const overlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: "rgba(0, 0, 0, 0.65)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 99998,
  pointerEvents: "all",
};

const modalStyle = {
  backgroundColor: "#fff",
  borderRadius: "12px",
  maxWidth: "480px",
  width: "90%",
  overflow: "hidden",
  boxShadow: "0 20px 60px rgba(0, 0, 0, 0.45)",
  position: "relative",
};

const closeButtonStyle = {
  position: "absolute",
  top: "12px",
  right: "12px",
  width: "32px",
  height: "32px",
  borderRadius: "50%",
  border: "none",
  backgroundColor: "rgba(0,0,0,0.5)",
  color: "#fff",
  fontSize: "18px",
  lineHeight: "32px",
  textAlign: "center",
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 1,
};

const bodyStyle = {
  padding: "1.5rem 2rem 2rem",
  textAlign: "center",
};

export default function EfemerideModal({ efemeride, onClose }) {
  if (!efemeride) return null;

  return (
    <div style={overlayStyle} onClick={onClose}>
      <div style={modalStyle} onClick={(e) => e.stopPropagation()}>
        <button style={closeButtonStyle} onClick={onClose} aria-label="Cerrar">
          ✕
        </button>

        {efemeride.imagen_url && (
          <img
            src={efemeride.imagen_url}
            alt={efemeride.titulo}
            style={{ width: "100%", maxHeight: "280px", objectFit: "cover", display: "block" }}
          />
        )}

        <div style={bodyStyle}>
          <h2 style={{ fontSize: "20px", fontWeight: 700, color: "#222", margin: "0 0 0.5rem" }}>
            {efemeride.titulo}
          </h2>
          {efemeride.descripcion && (
            <p style={{ fontSize: "14px", color: "#666", lineHeight: 1.6, margin: 0 }}>
              {efemeride.descripcion}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
